export default __webpack_public_path__ + "static/media/home-1.38a54f60.jpg";